import React from 'react'
import clutchLogo from '../assets/review-platforms/clutch.svg'
import goodfirmsLogo from '../assets/review-platforms/goodfirms.svg'
import selectedFirmsLogo from '../assets/review-platforms/selected-firms.svg'
import techReviewerLogo from '../assets/review-platforms/tech-reviewer.svg'
import trustpilotLogo from '../assets/review-platforms/trustpilot.svg'
import crunchbaseLogo from '../assets/review-platforms/crunchbase.svg'
import itprofilesLogo from '../assets/review-platforms/itprofiles.svg'
import techBehemothsLogo from '../assets/review-platforms/tech-behemoths.svg'

const platforms = [
  { name: 'Clutch Co', href: 'https://clutch.co/profile/metatech-official', logo: "https://yt3.googleusercontent.com/pruovX3F90ADRs5Jq3WBCePUvgCTvsAyaNH73OGyVnULvPNO8yHhM4MTy1i_QjY1S4thk17E_Zk=s900-c-k-c0x00ffffff-no-rj" },
  { name: 'Goodfirms', href: 'https://www.goodfirms.co/company/metatech-official', logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSlltYNXY7dYyoI0JqLXkZ-Xm9K_fXzCSkqrR2vt2hvxIf5ajvf7600vr9D&s=10" },
  { name: 'Selected Firms', href: 'https://selectedfirms.co/agency/metatech-official', logo: selectedFirmsLogo },
  { name: 'Tech Reviewer', href: 'https://techreviewer.co/companies/metatech-official', logo: techReviewerLogo },
  { name: 'Trust Pilot', href: 'https://www.trustpilot.com/review/metatech-official.com', logo: trustpilotLogo },
  { name: 'Crunchbase', href: 'https://www.crunchbase.com/organization/metatech-official', logo: crunchbaseLogo },
  { name: 'Itprofiles', href: 'https://itprofiles.com/company/metatech-official', logo: itprofilesLogo },
  { name: 'Tech Behemoths', href: 'https://techbehemoths.com/company/metatech-official', logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS9WJJUnmUMwg7J8vJ2JLS00zf3y-VT0TUAjxlbH9uQ8UK4UxHlo-xDkLA&s=10" },
]

const ReviewedPlatformsWebsite = () => {
  return (
    <section className="reviewed-platforms-section py-5">
      <div className="container">
        <div className="text-center mb-4">
          <h2 className="pb-3 h5 reviewed-platforms-eyebrow">REVIEWED BY TOP PLATFORMS</h2>
          <h3 className="display-6 fw-bold text-white mb-3">Recognized for website development services</h3>
          <p className="lead text-white-50 mx-auto reviewed-platforms-intro">
           Clients recognize Metatech Official as a trusted website development company for professional website development services, custom web solutions, and reliable digital products.
          </p>
        </div>
        <div className="row">
          {platforms.map((platform) => (
            <div className="col-12 col-sm-6 col-lg-3 my-2" key={platform.name}>
              <a className="reviewed-platform-card" href={platform.href} target="_blank" rel="noopener noreferrer" aria-label={`Visit Metatech Official on ${platform.name}`}>
                <div className="reviewed-platform-logo">
                  <img src={platform.logo} alt={`${platform.name} logo`} />
                </div>
                <div className="reviewed-platform-stars" aria-label="5 star recognition">
                  <i className="fa fa-star"></i>
                  <i className="fa fa-star"></i>
                  <i className="fa fa-star"></i>
                  <i className="fa fa-star"></i>
                  <i className="fa fa-star"></i>
                </div>
                <p>Recognized as a trusted web partner by {platform.name}</p>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default ReviewedPlatformsWebsite
